import { Theme } from '@savgroup-front-common/types';

import { BRAND_COLOR_VARIABLE_BY_COLOR_KEY } from './brandTokens';

interface ApplyThemeToCSSVariablesTheme {
  colors?: Partial<Theme['colors']>;
}

/**
 * Pushes the seller theme (theme.json) into the `--brand-*` CSS custom
 * properties on `:root`, so the Tailwind v4 / CVA design system reads the exact
 * same values as the legacy styled-components theme without any direct coupling.
 *
 * Only keys actually present on the seller theme are written, which lets the
 * static defaults declared in `globals.css` stand for anything the seller does
 * not override — guaranteeing zero visual change on apps that don't customize a
 * given token.
 */
export const applyThemeToCSSVariables = (
  theme?: ApplyThemeToCSSVariablesTheme,
): void => {
  if (typeof document === 'undefined' || !theme?.colors) {
    return;
  }

  const { style } = document.documentElement;
  const { colors } = theme;

  Object.entries(BRAND_COLOR_VARIABLE_BY_COLOR_KEY).forEach(
    ([colorKey, cssVariable]) => {
      const value = colors[colorKey as keyof typeof colors];

      if (value) {
        style.setProperty(cssVariable, value);
      }
    },
  );
};
